import { useEffect, useState } from "react";
import { Tag, Check, X, Loader2 } from "lucide-react";

export const REF_KEY = "cl_ref";

export default function ReferralCodeBox({ api, onChange }) {
  const [code, setCode] = useState(() => localStorage.getItem(REF_KEY) || "");
  const [state, setState] = useState({ status: "idle" });

  const check = async (raw) => {
    const c = raw.trim().toUpperCase();
    if (!c) {
      setState({ status: "idle" });
      localStorage.removeItem(REF_KEY);
      onChange(null);
      return;
    }
    setState({ status: "checking" });
    try {
      const { data } = await api.get(`/referral/validate/${encodeURIComponent(c)}`);
      if (data.valid) {
        localStorage.setItem(REF_KEY, data.code);
        setState({ status: "valid", pct: data.discount_pct, kind: data.kind });
        onChange({ code: data.code, pct: data.discount_pct, plans: data.plans, kind: data.kind });
      } else {
        localStorage.removeItem(REF_KEY);
        setState({ status: "invalid", reason: data.reason });
        onChange(null);
      }
    } catch {
      setState({ status: "invalid", reason: "Could not check the code. Try again." });
      onChange(null);
    }
  };

  useEffect(() => {
    if (code) check(code);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="brutal-border p-4 sm:p-5 mb-8 max-w-xl" data-testid="referral-code-box">
      <label htmlFor="ref-code" className="font-mono-label text-[10px] text-muted-foreground inline-flex items-center gap-1.5">
        <Tag size={12} className="text-[#FFD600]" /> HAVE A REFERRAL OR THANK-YOU CODE?
      </label>
      <div className="mt-2 flex gap-2">
        <input id="ref-code" value={code} maxLength={12} placeholder="e.g. CLAB12CD" autoCapitalize="characters"
          onChange={(e) => setCode(e.target.value.toUpperCase())} onKeyDown={(e) => e.key === "Enter" && check(code)}
          data-testid="referral-code-input"
          className="flex-1 min-w-0 h-11 px-3 bg-[#141414] border border-[#262626] text-white font-mono-label text-sm tracking-widest uppercase" />
        <button onClick={() => check(code)} data-testid="referral-code-apply"
          className="h-11 px-4 cta-primary font-mono-label text-[11px] inline-flex items-center gap-2">
          {state.status === "checking" ? <Loader2 size={13} className="animate-spin" /> : null} Apply
        </button>
      </div>
      {state.status === "valid" && (
        <p className="mt-2 text-sm text-[#4ADE80] inline-flex items-center gap-1.5" data-testid="referral-code-valid">
          <Check size={14} /> {state.kind === "thanks"
            ? `${state.pct}% off your next payment on any plan (one time)`
            : `${state.pct}% off every renewal of the 3-month, 6-month and annual plans`}
        </p>
      )}
      {state.status === "invalid" && (
        <p className="mt-2 text-sm text-[#F87171] inline-flex items-center gap-1.5" data-testid="referral-code-error">
          <X size={14} /> {state.reason}
        </p>
      )}
    </div>
  );
}
